import HeaderBigNumber from './HeaderBigNumber'
export default HeaderBigNumber
